import { createSlice } from '@reduxjs/toolkit'
import { routerChangeAction } from 'const'

const initialState = {
  currentSection: null,
  currentPath: null,
  previousPath: null,
}

const sections = [
  { name: 'primary', pathRegex: new RegExp('/primary/?') },
  { name: 'secondary', pathRegex: new RegExp('/secondary/?') },
  { name: 'ultrahigh-home', pathRegex: new RegExp('/ultra-high/home') },
  { name: 'private-wealth', pathRegex: new RegExp('/private-wealth-management/?') },
  { name: 'buy-sell-switch', pathRegex: new RegExp('/buy-sell-switching/?') },
]

const slice = createSlice({
  initialState,
  name: 'programSection',
  extraReducers: (builder) => {
    builder.addCase(routerChangeAction, (state, { payload }) => {
      state.previousPath = state.currentPath
      state.currentPath = payload.location.pathname
      for (const section of sections) {
        if (section.pathRegex.test(payload.location.pathname)) {
          state.currentSection = section.name
          break
        }
      }
    })
  },
})

export default slice;